import { createContext as e, useCallback as t, useContext as n, useEffect as r, useMemo as i, useRef as a, useState as o } from "react";
import { jsx as s, jsxs as c } from "react/jsx-runtime";
import { createPortal as l } from "react-dom";
//#region src/utils/dateUtils.ts
var u = /^(\d{4})-(\d{2})(?:-(\d{2}))?$/;
function d(e) {
	let t = e.match(u);
	if (!t) return null;
	let n = Number(t[1]), r = Number(t[2]), i = t[3] === void 0 ? 1 : Number(t[3]);
	if (r < 1 || r > 12 || i < 1 || i > 31) return null;
	let a = /* @__PURE__ */ new Date(0);
	return a.setFullYear(n, r - 1, i), a.setHours(0, 0, 0, 0), a;
}
function f(e) {
	if (!e) throw Error("Date string is required");
	let t = e.trim();
	if (/^-?\d+$/.test(t)) {
		let e = parseInt(t, 10), n = /* @__PURE__ */ new Date(0);
		return n.setFullYear(e, 0, 1), n.setHours(0, 0, 0, 0), n;
	}
	let n = d(t);
	if (n) return n;
	let r = new Date(t);
	if (!isNaN(r.getTime())) return r;
	for (let e of [
		/^([A-Za-z]+)\s+(\d{1,2})\s+(\d{4})$/,
		/^([A-Za-z]+)\s+(\d{1,2}),?\s+(\d{4})$/,
		/^(\d{1,2})\s+([A-Za-z]+)\s+(\d{4})$/
	]) if (t.match(e)) {
		let e = new Date(t);
		if (!isNaN(e.getTime())) return e;
	}
	throw Error(`Unable to parse date: ${e}`);
}
function p(e) {
	if (!e) return null;
	try {
		return f(e);
	} catch {
		return null;
	}
}
function m(e, t) {
	let n = e.getFullYear(), r = e.getMonth(), i = e.getDate(), a = e.getHours(), o = e.getMinutes(), s = [
		"Jan",
		"Feb",
		"Mar",
		"Apr",
		"May",
		"Jun",
		"Jul",
		"Aug",
		"Sep",
		"Oct",
		"Nov",
		"Dec"
	], c = [
		"January",
		"February",
		"March",
		"April",
		"May",
		"June",
		"July",
		"August",
		"September",
		"October",
		"November",
		"December"
	], l = (e) => e.toString().padStart(2, "0");
	switch (t) {
		case "yyyy": return n.toString();
		case "MMM": return s[r];
		case "MMMM": return c[r];
		case "MMM yyyy": return `${s[r]} ${n}`;
		case "MMMM yyyy": return `${c[r]} ${n}`;
		case "MMM d": return `${s[r]} ${i}`;
		case "MMM d, yyyy": return `${s[r]} ${i}, ${n}`;
		case "d": return i.toString();
		case "HH:mm": return `${l(a)}:${l(o)}`;
		case "h:mm a": {
			let e = a % 12 || 12, t = a < 12 ? "am" : "pm";
			return `${e}:${l(o)} ${t}`;
		}
		case "MMM d HH:mm": return `${s[r]} ${i} ${l(a)}:${l(o)}`;
		default: return `${n}-${l(r + 1)}-${l(i)}`;
	}
}
function h(e, t, n) {
	return (e.getTime() - t.getTime()) * n;
}
function g(e, t, n) {
	let r = e / n;
	return new Date(t.getTime() + r);
}
function _(e, t, n) {
	let r = t / 2 / n, i = e.getTime();
	return {
		start: new Date(i - r),
		end: new Date(i + r)
	};
}
function v(e) {
	if (e.length === 0) return /* @__PURE__ */ new Date();
	let t = e.map((e) => {
		let t = p(e.start);
		return t ? t.getTime() : null;
	}).filter((e) => e !== null).sort((e, t) => e - t);
	if (t.length === 0) return /* @__PURE__ */ new Date();
	let n = Math.floor(t.length / 2), r = t.length % 2 == 0 ? (t[n - 1] + t[n]) / 2 : t[n];
	return new Date(r);
}
var y = {
	millisecond: 1,
	second: 1e3,
	minute: 6e4,
	hour: 36e5,
	day: 864e5,
	week: 6048e5,
	month: 2592e6,
	year: 31536e6,
	decade: 31536e7,
	century: 31536e8
}, b = e(null);
function x(e, t = 800) {
	if (e.length === 0) return {
		detail: "day",
		overview: "month",
		detailIntervalPixels: 100,
		overviewIntervalPixels: 100
	};
	let n = e.map((e) => {
		try {
			return f(e.start).getTime();
		} catch {
			return null;
		}
	}).filter((e) => e !== null);
	if (n.length === 0) return {
		detail: "day",
		overview: "month",
		detailIntervalPixels: 100,
		overviewIntervalPixels: 100
	};
	let r = Math.min(...n), i = Math.max(...n) - r, a = i / y.year, o = i / y.month, s = i / y.day, c, l, u, d;
	return a > 50 ? (c = "decade", l = "century", u = Math.max(60, t / (a / 10)), d = Math.max(40, t / (a / 50))) : a > 10 ? (c = "year", l = "decade", u = Math.max(50, t / a), d = Math.max(40, t / (a / 5))) : a > 2 ? (c = "month", l = "year", u = Math.max(40, t / o), d = Math.max(50, t / a)) : o > 3 ? (c = "week", l = "month", u = Math.max(60, t / (s / 7)), d = Math.max(50, t / o)) : s > 7 ? (c = "day", l = "week", u = Math.max(80, t / s), d = Math.max(60, t / (s / 7))) : (c = "hour", l = "day", u = 100, d = 100), {
		detail: c,
		overview: l,
		detailIntervalPixels: u,
		overviewIntervalPixels: d
	};
}
function S(e) {
	let { detail: t, overview: n, detailIntervalPixels: r, overviewIntervalPixels: i } = x(e);
	return [{
		id: "detail",
		height: "70%",
		timeUnit: t,
		intervalPixels: r,
		overview: !1,
		showEventLabels: !0,
		trackHeight: 24,
		trackGap: 4
	}, {
		id: "overview",
		height: "30%",
		timeUnit: n,
		intervalPixels: i,
		overview: !0,
		syncWith: "detail",
		showEventLabels: !1
	}];
}
var C = [{
	id: "detail",
	height: "70%",
	timeUnit: "month",
	intervalPixels: 100,
	overview: !1,
	showEventLabels: !0,
	trackHeight: 24,
	trackGap: 4
}, {
	id: "overview",
	height: "30%",
	timeUnit: "year",
	intervalPixels: 100,
	overview: !0,
	syncWith: "detail",
	showEventLabels: !1
}];
function w(e) {
	let t = e.timeUnit || "day";
	return (e.intervalPixels || 100) / (y[t] || y.day);
}
function T(e, t) {
	if (e) {
		if (e instanceof Date) return e;
		let t = p(e);
		if (t) return t;
	}
	return v(t);
}
function E({ children: e, events: n, bands: c, hotZones: l, initialCenterDate: u, onScroll: d, onEventClick: p, onEventHover: m }) {
	let h = i(() => c && c.length > 0 ? c : S(n), [c, n]), g = w(h.find((e) => !e.overview) || h[0]), v = t(() => T(u, n), [u, n]), [y, x] = o(() => T(u, n)), [C, E] = o(800), [D, O] = o(null), [k, A] = o(null), [j, M] = o(null), [N, P] = o(!1), [F, I] = o(1), L = a(!0);
	r(() => {
		if (L.current) {
			L.current = !1;
			return;
		}
		u !== void 0 && x(v());
	}, [u, v]);
	let R = a({
		onScroll: d,
		onEventClick: p,
		onEventHover: m
	});
	r(() => {
		R.current = {
			onScroll: d,
			onEventClick: p,
			onEventHover: m
		};
	}, [
		d,
		p,
		m
	]);
	let z = t((e) => {
		x(e), R.current.onScroll?.(e);
	}, []), B = t((e) => {
		let t = e instanceof Date ? e : f(e);
		x(t), R.current.onScroll?.(t);
	}, []), V = t((e) => {
		x((t) => {
			let n = new Date(t.getTime() + e);
			return R.current.onScroll?.(n), n;
		});
	}, []), H = t((e, t) => {
		O(e), A(e && t || null), e && R.current.onEventClick?.(e);
	}, []), U = t((e) => {
		M(e), R.current.onEventHover?.(e);
	}, []), W = t((e) => {
		I((t) => Math.max(.1, Math.min(10, t * e)));
	}, []), G = i(() => g * F, [g, F]), K = i(() => _(y, C, G), [
		y,
		C,
		G
	]), q = i(() => ({
		centerDate: y,
		pixelsPerMillisecond: G,
		viewportWidth: C,
		selectedEvent: D,
		clickPosition: k,
		hoveredEvent: j,
		visibleRange: K,
		isPanning: N,
		zoomLevel: F
	}), [
		y,
		G,
		C,
		D,
		k,
		j,
		K,
		N,
		F
	]), J = i(() => ({
		setCenterDate: z,
		jumpToDate: B,
		pan: V,
		setSelectedEvent: H,
		setHoveredEvent: U,
		setIsPanning: P,
		setViewportWidth: E,
		zoom: W
	}), [
		z,
		B,
		V,
		H,
		U,
		W
	]), Y = i(() => l || [], [l]), X = i(() => ({
		state: q,
		actions: J,
		events: n,
		bands: h,
		hotZones: Y
	}), [
		q,
		J,
		n,
		h,
		Y
	]);
	return /* @__PURE__ */ s(b.Provider, {
		value: X,
		children: e
	});
}
function D() {
	let e = n(b);
	if (!e) throw Error("useTimelineContext must be used within a TimelineProvider");
	return e;
}
//#endregion
//#region src/hooks/usePan.ts
function O() {
	return typeof window < "u" && typeof window.matchMedia == "function" && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}
function k({ onPan: e, pixelsPerMs: n, onPanStart: i, onPanEnd: o, enableKeyboard: s = !0, scopeRef: c, keyboardPanAmount: l = 864e5, friction: u = .95, velocityThreshold: d = .01 }) {
	let f = a(!1), p = a(0), m = a(0), h = a(0), g = a(null), _ = a(null), v = a(null), y = a(e), b = a(i), x = a(o), S = a(n), C = a(u), w = a(d), T = a(c);
	r(() => {
		y.current = e, b.current = i, x.current = o, S.current = n, C.current = u, w.current = d, T.current = c;
	}, [
		e,
		i,
		o,
		n,
		u,
		d,
		c
	]);
	let E = t(() => {
		g.current !== null && (cancelAnimationFrame(g.current), g.current = null);
	}, []), D = t(() => {
		if (Math.abs(h.current) < w.current) {
			h.current = 0;
			return;
		}
		let e = -h.current * 16 / S.current;
		y.current(e), h.current *= C.current, g.current = requestAnimationFrame(D);
	}, []), k = t((e) => {
		if (!f.current) return;
		let t = performance.now(), n = t - m.current, r = e.clientX - p.current;
		n > 0 && (h.current = r / n);
		let i = -r / S.current;
		y.current(i), p.current = e.clientX, m.current = t;
	}, []), A = t(() => {
		if (f.current) {
			if (f.current = !1, x.current?.(), _.current && v.current !== null) try {
				_.current.releasePointerCapture(v.current);
			} catch {}
			O() || D(), document.removeEventListener("pointermove", k), document.removeEventListener("pointerup", A), document.removeEventListener("pointercancel", A);
		}
	}, [D, k]), j = t((e) => {
		if ((e.button === 0 || e.pointerType === "touch") && !e.target.closest(".timeline-event")) {
			e.currentTarget.focus({ preventScroll: !0 }), E(), f.current = !0, p.current = e.clientX, m.current = performance.now(), h.current = 0, _.current = e.currentTarget, v.current = e.pointerId, b.current?.();
			try {
				e.currentTarget.setPointerCapture(e.pointerId);
			} catch {}
			document.addEventListener("pointermove", k), document.addEventListener("pointerup", A), document.addEventListener("pointercancel", A), e.preventDefault();
		}
	}, [
		E,
		k,
		A
	]);
	return r(() => {
		if (!s) return;
		let e = (e) => {
			if (e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement) return;
			let t = T.current?.current;
			if (!(t && !t.contains(document.activeElement))) switch (e.key) {
				case "ArrowLeft":
					E(), y.current(-l), e.preventDefault();
					break;
				case "ArrowRight": E(), y.current(l), e.preventDefault();
			}
		};
		return window.addEventListener("keydown", e), () => window.removeEventListener("keydown", e);
	}, [
		s,
		l,
		E
	]), r(() => () => {
		E(), document.removeEventListener("pointermove", k), document.removeEventListener("pointerup", A), document.removeEventListener("pointercancel", A);
	}, [
		E,
		k,
		A
	]), {
		panProps: {
			onPointerDown: j,
			style: {
				cursor: f.current ? "grabbing" : "grab",
				touchAction: "none",
				userSelect: "none"
			}
		},
		isPanning: f.current
	};
}
//#endregion
//#region src/utils/scaleUtils.ts
var A = {
	"HH:mm": 45,
	"MMM d": 55,
	"MMM d HH:mm": 95,
	"MMM yyyy": 70,
	yyyy: 40
};
function j(e) {
	let t = y.minute, n = y.hour, r = y.day, i = y.month, a = y.year, o = (t, n) => t * e >= (A[n] || 60) + 10, s = [
		{
			unit: "minute",
			interval: 1,
			format: "HH:mm",
			tickMs: t
		},
		{
			unit: "minute",
			interval: 5,
			format: "HH:mm",
			tickMs: 5 * t
		},
		{
			unit: "minute",
			interval: 15,
			format: "HH:mm",
			tickMs: 15 * t
		},
		{
			unit: "minute",
			interval: 30,
			format: "HH:mm",
			tickMs: 30 * t
		},
		{
			unit: "hour",
			interval: 1,
			format: "HH:mm",
			tickMs: n
		},
		{
			unit: "hour",
			interval: 3,
			format: "HH:mm",
			tickMs: 3 * n
		},
		{
			unit: "hour",
			interval: 6,
			format: "HH:mm",
			tickMs: 6 * n
		},
		{
			unit: "hour",
			interval: 12,
			format: "MMM d HH:mm",
			tickMs: 12 * n
		},
		{
			unit: "day",
			interval: 1,
			format: "MMM d",
			tickMs: r
		},
		{
			unit: "day",
			interval: 3,
			format: "MMM d",
			tickMs: 3 * r
		},
		{
			unit: "week",
			interval: 1,
			format: "MMM d",
			tickMs: 7 * r
		},
		{
			unit: "week",
			interval: 2,
			format: "MMM d",
			tickMs: 14 * r
		},
		{
			unit: "month",
			interval: 1,
			format: "MMM yyyy",
			tickMs: i
		},
		{
			unit: "month",
			interval: 3,
			format: "MMM yyyy",
			tickMs: 3 * i
		},
		{
			unit: "month",
			interval: 6,
			format: "MMM yyyy",
			tickMs: 6 * i
		},
		{
			unit: "year",
			interval: 1,
			format: "yyyy",
			tickMs: a
		},
		{
			unit: "year",
			interval: 2,
			format: "yyyy",
			tickMs: 2 * a
		},
		{
			unit: "year",
			interval: 5,
			format: "yyyy",
			tickMs: 5 * a
		},
		{
			unit: "decade",
			interval: 1,
			format: "yyyy",
			tickMs: 10 * a
		},
		{
			unit: "decade",
			interval: 5,
			format: "yyyy",
			tickMs: 50 * a
		},
		{
			unit: "century",
			interval: 1,
			format: "yyyy",
			tickMs: 100 * a
		}
	];
	for (let e of s) if (o(e.tickMs, e.format)) return e;
	return s[s.length - 1];
}
function M(e, t, n = 1) {
	let r = new Date(e);
	switch (t) {
		case "minute":
			r.setSeconds(0, 0), r.setMinutes(Math.floor(r.getMinutes() / n) * n);
			break;
		case "hour":
			r.setMinutes(0, 0, 0), r.setHours(Math.floor(r.getHours() / n) * n);
			break;
		case "day":
			r.setHours(0, 0, 0, 0);
			break;
		case "week":
			r.setHours(0, 0, 0, 0), r.setDate(r.getDate() - r.getDay());
			break;
		case "month":
			r.setHours(0, 0, 0, 0), r.setDate(1), r.setMonth(Math.floor(r.getMonth() / n) * n);
			break;
		case "year":
			r.setHours(0, 0, 0, 0), r.setMonth(0, 1), r.setFullYear(Math.floor(r.getFullYear() / n) * n);
			break;
		case "decade":
			r.setHours(0, 0, 0, 0), r.setMonth(0, 1), r.setFullYear(Math.floor(r.getFullYear() / 10) * 10);
			break;
		case "century": r.setHours(0, 0, 0, 0), r.setMonth(0, 1), r.setFullYear(Math.floor(r.getFullYear() / 100) * 100);
	}
	return r;
}
function N(e, t, n = 1) {
	let r = new Date(e);
	switch (t) {
		case "millisecond":
			r.setMilliseconds(r.getMilliseconds() + n);
			break;
		case "second":
			r.setSeconds(r.getSeconds() + n);
			break;
		case "minute":
			r.setMinutes(r.getMinutes() + n);
			break;
		case "hour":
			r.setHours(r.getHours() + n);
			break;
		case "day":
			r.setDate(r.getDate() + n);
			break;
		case "week":
			r.setDate(r.getDate() + n * 7);
			break;
		case "month":
			r.setMonth(r.getMonth() + n);
			break;
		case "year":
			r.setFullYear(r.getFullYear() + n);
			break;
		case "decade":
			r.setFullYear(r.getFullYear() + n * 10);
			break;
		case "century": r.setFullYear(r.getFullYear() + n * 100);
	}
	return r;
}
function P(e, t) {
	switch (t) {
		case "minute":
		case "hour": return e.getHours() === 0 && e.getMinutes() === 0;
		case "day":
		case "week": return e.getDate() === 1;
		case "month": return e.getMonth() === 0;
		case "year":
		case "decade": return e.getFullYear() % 10 == 0;
		case "century": return e.getFullYear() % 100 == 0;
		default: return !1;
	}
}
function F(e, t, n, r, i) {
	let a = [], o = r.getTime() - i / 2 / n, s = M(new Date(e.start.getTime() - t.tickMs), t.unit, t.interval), c = 0;
	for (; s <= e.end && c < 200;) {
		let e = (s.getTime() - o) * n;
		e >= -100 && e <= i + 100 && a.push({
			date: new Date(s),
			label: m(s, t.format),
			x: e,
			isMajor: P(s, t.unit)
		}), s = N(s, t.unit, t.interval), c++;
	}
	return a;
}
//#endregion
//#region src/components/TimeScale.tsx
function I(e) {
	return e % 10 == 0;
}
function L({ visibleRange: e, pixelsPerMs: t, viewportWidth: n, centerDate: r }) {
	let a = i(() => j(t), [t]), o = i(() => F(e, a, t, r, n), [
		e,
		a,
		t,
		r,
		n
	]);
	return /* @__PURE__ */ c("div", {
		className: "timeline-scale",
		"aria-hidden": "true",
		style: {
			position: "relative",
			width: "100%",
			height: "100%",
			overflow: "hidden"
		},
		children: [/* @__PURE__ */ s("div", {
			className: "timeline-scale__baseline",
			style: {
				position: "absolute",
				top: 0,
				left: 0,
				right: 0,
				height: 1,
				backgroundColor: "var(--scale-line-color, #e0e0e0)"
			}
		}), o.map((e) => /* @__PURE__ */ s(R, { tick: e }, e.date.getTime()))]
	});
}
function R({ tick: e }) {
	let t = I(e.date.getFullYear()), n = e.isMajor || t;
	return /* @__PURE__ */ c("div", {
		className: `timeline-scale__tick ${e.isMajor ? "timeline-scale__tick--major" : ""}`,
		style: {
			position: "absolute",
			left: e.x,
			top: 0,
			transform: "translateX(-50%)",
			pointerEvents: "none",
			height: "100%",
			display: "flex",
			flexDirection: "column",
			alignItems: "center"
		},
		children: [/* @__PURE__ */ s("div", {
			className: "timeline-scale__tick-line",
			style: {
				width: 1,
				height: n ? 6 : 4,
				backgroundColor: n ? "var(--scale-major-line-color, #999)" : "var(--scale-line-color, #ccc)",
				flexShrink: 0
			}
		}), /* @__PURE__ */ s("span", {
			className: "timeline-scale__label",
			style: {
				fontSize: "var(--scale-font-size, 11px)",
				color: n ? "var(--scale-major-text-color, #333)" : "var(--scale-text-color, #666)",
				whiteSpace: "nowrap",
				fontFamily: "var(--timeline-font-family, system-ui, sans-serif)",
				fontWeight: n ? 600 : 400,
				marginTop: 2
			},
			children: e.label
		})]
	});
}
//#endregion
//#region src/utils/layoutEngine.ts
var z = 7, B = 10, V = 6, H = 8, U = 20, W = 8;
function G(e) {
	return !!(e.end || e.isDuration || e.durationEvent);
}
function K(e, t = !0) {
	return t ? 16 + e.length * z : B;
}
function q(e, t, n = 864e5) {
	let r = t.start.getTime() - n, i = t.end.getTime() + n;
	return e.filter((e) => {
		try {
			let t = f(e.start).getTime();
			if (G(e) && e.end) {
				let n = f(e.end).getTime();
				return t <= i && n >= r;
			}
			return t >= r && t <= i;
		} catch {
			return !1;
		}
	});
}
function J(e) {
	let t = [], n = [];
	return e.forEach((e, r) => {
		let i;
		try {
			if (i = f(e.start).getTime(), Number.isNaN(i)) return;
		} catch {
			return;
		}
		if (G(e) && e.end) {
			let t;
			try {
				if (t = f(e.end).getTime(), Number.isNaN(t)) return;
			} catch {
				return;
			}
			n.push({
				event: e,
				index: r,
				startMs: i,
				endMs: t,
				isDuration: !0
			});
		} else t.push({
			event: e,
			index: r,
			startMs: i,
			isDuration: G(e)
		});
	}), t.sort((e, t) => e.startMs - t.startMs), {
		points: t,
		durations: n
	};
}
function Y(e, t) {
	let n = 0, r = e.length;
	for (; n < r;) {
		let i = n + r >>> 1;
		e[i].startMs < t ? n = i + 1 : r = i;
	}
	return n;
}
function X(e, t, n = 864e5) {
	let r = t.start.getTime() - n, i = t.end.getTime() + n, { points: a, durations: o } = e, s = [];
	for (let e = Y(a, r); e < a.length && !(a[e].startMs > i); e++) s.push(a[e]);
	for (let e of o) e.startMs <= i && (e.endMs ?? e.startMs) >= r && s.push(e);
	return s.sort((e, t) => e.index - t.index), s;
}
function ee(e) {
	return e.map((e) => e.x >= 0 ? e : e.isDuration && e.endX !== void 0 && e.endX > W || !e.isDuration && e.x > -e.width ? {
		...e,
		isSticky: !0,
		stickyX: W
	} : e);
}
function Z(e, t = 0) {
	if (e.length === 0) return [];
	let n = [...e].sort((e, t) => e.x - t.x), r = [];
	for (let e of n) {
		let n = -1, i = t > 0 ? Math.min(r.length, t) : r.length;
		for (let t = 0; t < i; t++) if (e.x >= r[t] + H) {
			n = t;
			break;
		}
		if (n === -1) {
			if (t > 0 && r.length >= t) {
				let e = Infinity, t = 0;
				for (let n = 0; n < r.length; n++) r[n] < e && (e = r[n], t = n);
				n = t;
			} else n = r.length;
		}
		e.track = n, r[n] = e.x + e.width;
	}
	return n;
}
function te(e, t, n, r, i, a = !0, o = 0) {
	return Q(J(e), t, n, r, i, a, o);
}
function Q(e, t, n, r, i, a = !0, o = 0) {
	let s = r.getTime() - i / 2 / n;
	return ee(Z(X(e, t).map(({ event: e, startMs: t, endMs: r, isDuration: i }) => {
		let o = (t - s) * n, c, l, u;
		return i && r !== void 0 ? (l = (r - s) * n, u = Math.max(l - o, U), c = u + (a ? V + e.title.length * z : 0)) : c = K(e.title, a), {
			event: e,
			x: o,
			width: c,
			track: 0,
			isDuration: i,
			endX: l,
			durationWidth: u
		};
	}), o));
}
function $(e) {
	return e.length === 0 ? 1 : Math.max(...e.map((e) => e.track)) + 1;
}
//#endregion
//#region src/components/EventMarker.tsx
var ne = "#4a90d9", re = "#6ba3d6", ie = 18;
function ae({ event: e, x: n, y: r, showLabel: i = !0, isDuration: a = !1, durationWidth: o, isSticky: l = !1, stickyX: u }) {
	let { state: d, actions: p } = D(), h = d.selectedEvent === e, g = t((t) => {
		p.setSelectedEvent(h ? null : e, t);
	}, [
		p,
		e,
		h
	]), _ = t((e) => {
		e.stopPropagation(), g({
			x: e.clientX,
			y: e.clientY
		});
	}, [g]), v = t((e) => {
		if (e.key !== "Enter" && e.key !== " ") return;
		e.preventDefault(), e.stopPropagation();
		let t = e.currentTarget.getBoundingClientRect();
		g({
			x: t.left + t.width / 2,
			y: t.top + t.height / 2
		});
	}, [g]), y = e.color || (a ? re : ne), b = e.textColor || "var(--event-text-color, #333)", x = e.start;
	try {
		x = m(f(e.start), "MMM d, yyyy"), e.end && (x += ` to ${m(f(e.end), "MMM d, yyyy")}`);
	} catch {}
	let S = e.description ? `: ${e.description.substring(0, 100)}${e.description.length > 100 ? "..." : ""}` : "", C = `${e.title}, ${x}${S}`;
	if (a && o) {
		let t = l && u !== void 0 ? u - n : void 0;
		return /* @__PURE__ */ c("div", {
			className: `timeline-event timeline-event--duration ${h ? "timeline-event--selected" : ""} ${l ? "timeline-event--sticky" : ""} ${e.classname || ""}`,
			style: {
				position: "absolute",
				left: n,
				top: r,
				display: "flex",
				alignItems: "center",
				cursor: "pointer",
				zIndex: h ? 10 : l ? 5 : 1,
				pointerEvents: "auto"
			},
			onClick: _,
			"data-event-id": e.title,
			role: "button",
			tabIndex: 0,
			"aria-label": C,
			"aria-pressed": h,
			onKeyDown: v,
			children: [/* @__PURE__ */ s("div", {
				className: "timeline-event__tape",
				style: {
					width: o,
					height: ie,
					backgroundColor: y,
					borderRadius: 3,
					flexShrink: 0,
					boxShadow: h ? `0 0 0 2px var(--event-selected-ring-color, white), 0 0 0 4px ${y}` : "0 1px 3px rgba(0,0,0,0.2)",
					transition: "box-shadow 0.15s ease",
					backgroundImage: e.tapeImage ? `url(${e.tapeImage})` : void 0,
					backgroundRepeat: e.tapeRepeat || "repeat",
					opacity: h ? 1 : .85
				}
			}), i && /* @__PURE__ */ c("span", {
				className: `timeline-event__label ${l ? "timeline-event__label--sticky" : ""}`,
				style: {
					position: t === void 0 ? "relative" : "absolute",
					left: t === void 0 ? void 0 : t,
					marginLeft: t === void 0 ? 6 : 0,
					fontSize: "var(--event-font-size, 12px)",
					fontFamily: "var(--timeline-font-family, system-ui, sans-serif)",
					color: b,
					whiteSpace: "nowrap",
					fontWeight: h || l ? 600 : 400,
					textShadow: l ? "none" : "var(--event-text-shadow, 0 0 2px white, 0 0 2px white)",
					backgroundColor: l ? "var(--sticky-label-bg, rgba(255, 255, 255, 0.95))" : void 0,
					padding: l ? "2px 6px" : void 0,
					borderRadius: l ? 3 : void 0,
					boxShadow: l ? "var(--sticky-label-shadow, 0 1px 4px rgba(0,0,0,0.2))" : void 0,
					display: "flex",
					alignItems: "center"
				},
				children: [l && /* @__PURE__ */ s("span", {
					style: {
						marginRight: 4,
						opacity: .5
					},
					children: "◀"
				}), e.title]
			})]
		});
	}
	let w = l && u !== void 0 ? u - n : void 0;
	return /* @__PURE__ */ c("div", {
		className: `timeline-event ${h ? "timeline-event--selected" : ""} ${l ? "timeline-event--sticky" : ""} ${e.classname || ""}`,
		style: {
			position: "absolute",
			left: n,
			top: r,
			display: "flex",
			alignItems: "center",
			cursor: "pointer",
			zIndex: h ? 10 : l ? 5 : 1,
			pointerEvents: "auto"
		},
		onClick: _,
		"data-event-id": e.title,
		role: "button",
		tabIndex: 0,
		"aria-label": C,
		"aria-pressed": h,
		onKeyDown: (e) => {
			(e.key === "Enter" || e.key === " ") && (e.preventDefault(), _(e));
		},
		children: [!l && /* @__PURE__ */ s("div", {
			className: "timeline-event__dot",
			style: {
				width: 10,
				height: 10,
				borderRadius: "50%",
				backgroundColor: y,
				flexShrink: 0,
				boxShadow: h ? `0 0 0 2px var(--event-selected-ring-color, white), 0 0 0 4px ${y}` : "none",
				transition: "box-shadow 0.15s ease"
			}
		}), i && /* @__PURE__ */ c("span", {
			className: `timeline-event__label ${l ? "timeline-event__label--sticky" : ""}`,
			style: {
				position: w === void 0 ? "relative" : "absolute",
				left: w === void 0 ? void 0 : w,
				marginLeft: w === void 0 ? 6 : 0,
				fontSize: "var(--event-font-size, 12px)",
				fontFamily: "var(--timeline-font-family, system-ui, sans-serif)",
				color: b,
				whiteSpace: "nowrap",
				fontWeight: h || l ? 600 : 400,
				textShadow: l ? "none" : "var(--event-text-shadow, 0 0 2px white, 0 0 2px white)",
				backgroundColor: l ? "var(--sticky-label-bg, rgba(255, 255, 255, 0.95))" : void 0,
				padding: l ? "2px 6px" : void 0,
				borderRadius: l ? 3 : void 0,
				boxShadow: l ? "var(--sticky-label-shadow, 0 1px 4px rgba(0,0,0,0.2))" : void 0,
				display: "flex",
				alignItems: "center"
			},
			children: [l && /* @__PURE__ */ s("span", {
				className: "timeline-event__sticky-indicator",
				style: {
					width: 8,
					height: 8,
					borderRadius: "50%",
					backgroundColor: y,
					marginRight: 6,
					flexShrink: 0
				}
			}), e.title]
		})]
	});
}
//#endregion
//#region src/components/EventTrack.tsx
function oe({ events: e, visibleRange: t, pixelsPerMs: n, viewportWidth: r, centerDate: a, trackHeight: o = 24, trackGap: c = 4, showLabels: l = !0, maxTracks: u = 0 }) {
	let d = i(() => J(e), [e]), f = i(() => Q(d, t, n, a, r, l, u), [
		d,
		t,
		n,
		a,
		r,
		l,
		u
	]), p = i(() => $(f), [f]) * (o + c);
	return /* @__PURE__ */ s("div", {
		className: "timeline-event-track",
		role: "group",
		"aria-label": `Timeline events, ${f.length} in view`,
		style: {
			position: "relative",
			width: "100%",
			height: "100%",
			minHeight: p
		},
		children: f.map((e) => {
			let t = e.track * (o + c) + c;
			return /* @__PURE__ */ s(ae, {
				event: e.event,
				x: e.x,
				y: t,
				showLabel: l,
				isDuration: e.isDuration,
				durationWidth: e.durationWidth,
				isSticky: e.isSticky,
				stickyX: e.stickyX
			}, `${e.event.title}-${e.event.start}-${e.event.end ?? ""}`);
		})
	});
}
//#endregion
//#region src/components/OverviewMarkers.tsx
var se = "#666";
function ce({ events: e, visibleRange: t, pixelsPerMs: n, viewportWidth: r, centerDate: a }) {
	let o = i(() => J(e), [e]), c = i(() => {
		let e = a.getTime() - r / 2 / n;
		return X(o, t, 6048e5).map(({ event: t, startMs: r }) => ({
			event: t,
			x: (r - e) * n,
			color: t.color || se
		}));
	}, [
		o,
		t,
		n,
		r,
		a
	]);
	return /* @__PURE__ */ s("div", {
		className: "timeline-overview-markers",
		"aria-hidden": "true",
		style: {
			position: "relative",
			width: "100%",
			height: "100%",
			display: "flex",
			alignItems: "flex-end",
			paddingBottom: 4
		},
		children: c.map((e) => /* @__PURE__ */ s("div", {
			className: "timeline-overview-marker",
			style: {
				position: "absolute",
				left: e.x,
				bottom: 4,
				width: 2,
				height: "var(--overview-marker-height, 12px)",
				backgroundColor: e.color,
				transform: "translateX(-50%)"
			},
			title: e.event.title
		}, `${e.event.title}-${e.event.start}-${e.event.end ?? ""}`))
	});
}
//#endregion
//#region src/components/HotZones.tsx
var le = "rgba(255, 220, 100, 0.3)";
function ue({ hotZones: e, visibleRange: t, pixelsPerMs: n, viewportWidth: r, centerDate: a }) {
	let o = i(() => {
		let i = a.getTime() - r / 2 / n, o = new Date(i);
		return e.map((e) => {
			try {
				let r = f(e.start), i = f(e.end), a = r.getTime();
				if (i.getTime() < t.start.getTime() || a > t.end.getTime()) return null;
				let s = h(r, o, n);
				return {
					zone: e,
					x: s,
					width: h(i, o, n) - s,
					color: e.color || le,
					annotation: e.annotation
				};
			} catch {
				return null;
			}
		}).filter((e) => e !== null);
	}, [
		e,
		t,
		a,
		r,
		n
	]);
	return o.length === 0 ? null : /* @__PURE__ */ s("div", {
		className: "timeline-hot-zones",
		style: {
			position: "absolute",
			top: 0,
			left: 0,
			right: 0,
			bottom: 0,
			pointerEvents: "none",
			overflow: "hidden"
		},
		children: o.map((e) => /* @__PURE__ */ s("div", {
			className: "timeline-hot-zone",
			...e.annotation ? {
				role: "note",
				"aria-label": `${e.annotation} period`
			} : { "aria-hidden": !0 },
			style: {
				position: "absolute",
				left: e.x,
				top: 0,
				width: e.width,
				height: "100%",
				backgroundColor: e.color,
				borderLeft: "1px solid var(--hot-zone-border-color, rgba(0, 0, 0, 0.1))",
				borderRight: "1px solid var(--hot-zone-border-color, rgba(0, 0, 0, 0.1))"
			},
			children: e.annotation && /* @__PURE__ */ s("div", {
				className: "timeline-hot-zone__annotation",
				"aria-hidden": "true",
				style: {
					position: "absolute",
					bottom: 28,
					left: 4,
					right: 4,
					fontSize: "10px",
					fontFamily: "var(--timeline-font-family, system-ui, sans-serif)",
					color: "var(--hot-zone-text-color, #888)",
					whiteSpace: "nowrap",
					overflow: "hidden",
					textOverflow: "ellipsis",
					fontWeight: 500,
					fontStyle: "italic"
				},
				children: e.annotation
			})
		}, `hotzone-${e.zone.start}-${e.zone.end}`))
	});
}
//#endregion
//#region src/components/Band.tsx
function de(e) {
	let t = e.timeUnit || "day";
	return (e.intervalPixels || 100) / (y[t] || y.day);
}
function fe({ config: e, isPrimary: n = !1 }) {
	let o = a(null), { state: l, actions: u, events: d, hotZones: f } = D(), p = i(() => de(e) * l.zoomLevel, [e, l.zoomLevel]), m = i(() => _(l.centerDate, l.viewportWidth, p), [
		l.centerDate,
		l.viewportWidth,
		p
	]), { panProps: h } = k({
		onPan: t((e) => {
			u.pan(e);
		}, [u]),
		pixelsPerMs: p,
		onPanStart: () => u.setIsPanning(!0),
		onPanEnd: () => u.setIsPanning(!1),
		enableKeyboard: n,
		scopeRef: o,
		keyboardPanAmount: i(() => l.viewportWidth / p * .1, [l.viewportWidth, p])
	});
	r(() => {
		let e = o.current;
		if (!e) return;
		let t = () => {
			n && u.setViewportWidth(e.clientWidth);
		}, r = (e) => {
			e.preventDefault();
			let t = e.deltaY < 0 ? 1.15 : .87;
			u.zoom(t);
		};
		t();
		let i = new ResizeObserver(t);
		return i.observe(e), e.addEventListener("wheel", r, { passive: !1 }), () => {
			i.disconnect(), e.removeEventListener("wheel", r);
		};
	}, [n, u]), r(() => {
		if (!n) return;
		let e = (e) => {
			if (e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement) return;
			let t = o.current;
			if (!(!t || !t.contains(document.activeElement))) switch (e.key) {
				case "+":
				case "=":
					u.zoom(1.15), e.preventDefault();
					break;
				case "-":
				case "_": u.zoom(.87), e.preventDefault();
			}
		};
		return window.addEventListener("keydown", e), () => window.removeEventListener("keydown", e);
	}, [n, u]);
	let g = e.height || (e.overview ? "30%" : "70%");
	return /* @__PURE__ */ c("div", {
		ref: o,
		className: `timeline-band ${e.overview ? "timeline-band--overview" : "timeline-band--detail"}`,
		style: {
			height: g,
			position: "relative",
			overflow: "hidden",
			backgroundColor: "var(--band-bg, #ffffff)",
			borderBottom: "1px solid var(--band-border, #e0e0e0)",
			...h.style
		},
		onPointerDown: h.onPointerDown,
		"data-band-id": e.id,
		...n ? {
			tabIndex: 0,
			role: "group",
			"aria-label": "Timeline. Use the left and right arrow keys to pan, and the plus and minus keys to zoom.",
			"aria-keyshortcuts": "ArrowLeft ArrowRight + -"
		} : {},
		children: [
			f.length > 0 && /* @__PURE__ */ s(ue, {
				hotZones: f,
				visibleRange: m,
				pixelsPerMs: p,
				viewportWidth: l.viewportWidth,
				centerDate: l.centerDate
			}),
			/* @__PURE__ */ s("div", {
				className: "timeline-band__events",
				style: {
					position: "absolute",
					top: 0,
					left: 0,
					right: 0,
					bottom: 48,
					overflow: "hidden",
					pointerEvents: "none"
				},
				children: e.overview ? /* @__PURE__ */ s(ce, {
					events: d,
					visibleRange: m,
					pixelsPerMs: p,
					viewportWidth: l.viewportWidth,
					centerDate: l.centerDate
				}) : /* @__PURE__ */ s(oe, {
					events: d,
					visibleRange: m,
					pixelsPerMs: p,
					viewportWidth: l.viewportWidth,
					centerDate: l.centerDate,
					trackHeight: e.trackHeight || 24,
					trackGap: e.trackGap || 4,
					showLabels: e.showEventLabels !== !1
				})
			}),
			/* @__PURE__ */ s("div", {
				className: "timeline-band__scale",
				style: {
					position: "absolute",
					bottom: 0,
					left: 0,
					right: 0,
					height: 24,
					borderTop: "1px solid var(--scale-line-color, #e0e0e0)",
					backgroundColor: "var(--scale-bg, #fafafa)"
				},
				children: /* @__PURE__ */ s(L, {
					visibleRange: m,
					pixelsPerMs: p,
					viewportWidth: l.viewportWidth,
					centerDate: l.centerDate,
					timeUnit: e.timeUnit
				})
			})
		]
	});
}
//#endregion
//#region src/components/EventPopup.tsx
function pe(e, t, n, r) {
	let i = window.innerWidth, a = window.innerHeight, o = e + 12, s = t - r / 2;
	return o + n + 16 > i && (o = e - n - 12), o < 16 && (o = Math.max(16, (i - n) / 2)), s < 16 ? s = 16 : s + r + 16 > a && (s = a - r - 16), {
		top: s,
		left: o
	};
}
function me({ themeAttr: e, themeStyles: n }) {
	let { state: i, actions: u } = D(), d = a(null), { selectedEvent: p, clickPosition: h } = i, [g, _] = o(null);
	r(() => {
		if (!p) return;
		let e = (e) => {
			if (d.current && !d.current.contains(e.target)) {
				if (e.target.closest(".timeline-event")) return;
				u.setSelectedEvent(null);
			}
		}, t = setTimeout(() => {
			document.addEventListener("click", e);
		}, 0);
		return () => {
			clearTimeout(t), document.removeEventListener("click", e);
		};
	}, [p, u]), r(() => {
		if (!p) return;
		let e = document.activeElement, t = () => {
			let e = d.current;
			return e ? Array.from(e.querySelectorAll("a[href], button:not([disabled]), [tabindex]:not([tabindex=\"-1\"]), input:not([disabled]), select:not([disabled]), textarea:not([disabled])")) : [];
		}, n = setTimeout(() => {
			(t()[0] ?? d.current)?.focus();
		}, 0), r = (e) => {
			if (e.key === "Escape") {
				u.setSelectedEvent(null);
				return;
			}
			if (e.key !== "Tab") return;
			let n = t();
			if (n.length === 0) {
				e.preventDefault(), d.current?.focus();
				return;
			}
			let r = n[0], i = n[n.length - 1], a = document.activeElement;
			e.shiftKey ? (a === r || !d.current?.contains(a)) && (e.preventDefault(), i.focus()) : (a === i || !d.current?.contains(a)) && (e.preventDefault(), r.focus());
		};
		return document.addEventListener("keydown", r), () => {
			clearTimeout(n), document.removeEventListener("keydown", r), e && document.contains(e) && e.focus();
		};
	}, [p, u]), r(() => {
		if (!p || !h || !d.current) {
			_(null);
			return;
		}
		let e = d.current.getBoundingClientRect(), t = pe(h.x, h.y, e.width, e.height);
		_(t);
	}, [p, h]);
	let v = t(() => {
		u.setSelectedEvent(null);
	}, [u]);
	if (!p) return null;
	let y;
	try {
		if (y = m(f(p.start), "MMM d, yyyy"), p.end) {
			let e = f(p.end);
			y += ` - ${m(e, "MMM d, yyyy")}`;
		}
	} catch {
		y = p.start;
	}
	let b = g ? {
		position: "fixed",
		top: g.top,
		left: g.left,
		backgroundColor: "var(--popup-bg, #ffffff)",
		border: "1px solid var(--popup-border, #cccccc)",
		borderRadius: 8,
		boxShadow: "var(--popup-shadow, 0 4px 16px rgba(0,0,0,0.15))",
		padding: 16,
		maxWidth: 400,
		minWidth: 280,
		zIndex: 1e3,
		fontFamily: "var(--timeline-font-family, system-ui, sans-serif)"
	} : {
		position: "fixed",
		top: "50%",
		left: "50%",
		transform: "translate(-50%, -50%)",
		backgroundColor: "var(--popup-bg, #ffffff)",
		border: "1px solid var(--popup-border, #cccccc)",
		borderRadius: 8,
		boxShadow: "var(--popup-shadow, 0 4px 16px rgba(0,0,0,0.15))",
		padding: 16,
		maxWidth: 400,
		minWidth: 280,
		zIndex: 1e3,
		fontFamily: "var(--timeline-font-family, system-ui, sans-serif)",
		visibility: "hidden"
	}, x = /* @__PURE__ */ c("div", {
		ref: d,
		className: "timeline-popup",
		style: b,
		role: "dialog",
		"aria-modal": "true",
		tabIndex: -1,
		"aria-labelledby": "popup-title",
		"aria-describedby": p.description ? "popup-description" : void 0,
		children: [
			/* @__PURE__ */ s("button", {
				onClick: v,
				className: "timeline-popup__close",
				style: {
					position: "absolute",
					top: 8,
					right: 8,
					background: "none",
					border: "none",
					fontSize: 20,
					cursor: "pointer",
					color: "var(--popup-close-color, #666)",
					padding: 4,
					lineHeight: 1
				},
				"aria-label": "Close popup",
				children: "×"
			}),
			/* @__PURE__ */ s("h3", {
				id: "popup-title",
				className: "timeline-popup__title",
				style: {
					margin: "0 0 8px 0",
					fontSize: 16,
					fontWeight: 600,
					color: "var(--popup-title-color, #1a1a1a)",
					borderLeft: `3px solid ${p.color || "var(--event-default-color, #4a90d9)"}`,
					paddingLeft: 8,
					paddingRight: 24
				},
				children: p.title
			}),
			/* @__PURE__ */ s("div", {
				className: "timeline-popup__date",
				style: {
					fontSize: 13,
					color: "var(--popup-date-color, #595959)",
					marginBottom: 12
				},
				children: y
			}),
			p.description && /* @__PURE__ */ s("div", {
				id: "popup-description",
				className: "timeline-popup__description",
				style: {
					fontSize: 14,
					color: "var(--popup-text-color, #333)",
					lineHeight: 1.5
				},
				dangerouslySetInnerHTML: { __html: p.description }
			}),
			p.link && /* @__PURE__ */ s("a", {
				href: p.link,
				target: "_blank",
				rel: "noopener noreferrer",
				className: "timeline-popup__link",
				style: {
					display: "inline-block",
					marginTop: 12,
					fontSize: 13,
					color: "var(--popup-link-color, #0066cc)",
					textDecoration: "none"
				},
				children: "More information →"
			}),
			p.image && /* @__PURE__ */ s("div", {
				className: "timeline-popup__image",
				style: { marginTop: 12 },
				children: /* @__PURE__ */ s("img", {
					src: p.image,
					alt: p.title,
					style: {
						maxWidth: "100%",
						maxHeight: 200,
						borderRadius: 4
					}
				})
			})
		]
	});
	return l(/* @__PURE__ */ s("div", {
		className: "timeline-root",
		"data-theme": e,
		style: {
			display: "contents",
			...n
		},
		children: x
	}), document.body);
}
//#endregion
//#region src/components/Timeline.tsx
function he() {
	let { bands: e } = D();
	return /* @__PURE__ */ s("div", {
		className: "timeline-bands",
		style: {
			display: "flex",
			flexDirection: "column",
			height: "100%"
		},
		children: e.map((e, t) => /* @__PURE__ */ s(fe, {
			config: e,
			isPrimary: t === 0 || !e.syncWith
		}, e.id ?? `band-${e.timeUnit ?? "auto"}-${e.overview ? "ov" : "main"}-${e.height ?? ""}`))
	});
}
function ge({ config: e }) {
	let { text: t, link: n, position: r = "bottom-left", showPoweredBy: i = !1 } = e, a = t || "React Simile Timeline", o = i ? `Powered by ${a}` : a, c = {
		position: "absolute",
		zIndex: 100,
		...r.includes("bottom") ? { bottom: 8 } : { top: 8 },
		...r.includes("right") ? { right: 8 } : { left: 4 }
	}, l = /* @__PURE__ */ s("span", {
		className: "timeline-branding",
		style: {
			fontSize: "11px",
			fontFamily: "var(--timeline-font-family, system-ui, sans-serif)",
			color: "var(--scale-text-color, #888)",
			opacity: .5,
			writingMode: "vertical-rl",
			textOrientation: "mixed",
			transform: "rotate(180deg)",
			whiteSpace: "nowrap",
			letterSpacing: "0.5px"
		},
		children: o
	});
	return n ? /* @__PURE__ */ s("a", {
		href: n,
		target: "_blank",
		rel: "noopener noreferrer",
		style: {
			...c,
			textDecoration: "none"
		},
		children: l
	}) : /* @__PURE__ */ s("span", {
		style: c,
		children: l
	});
}
function _e({ data: e, dataUrl: t, dataUrls: n, bands: i, hotZones: l, theme: u = "classic", centerDate: d, width: f = "100%", height: m = 400, onEventClick: h, onEventHover: g, onScroll: _, onZoom: v, className: y, style: b, branding: x }) {
	let [S, C] = o(e || null), [w, T] = o(!!t || n && n.length > 0), [D, O] = o(null), k = a(null);
	r(() => {
		if (!t) return;
		let e = new AbortController();
		return T(!0), O(null), fetch(t, { signal: e.signal }).then((e) => {
			if (!e.ok) throw Error(`Failed to fetch timeline data: ${e.statusText}`);
			return e.json();
		}).then((e) => {
			C(e), T(!1);
		}).catch((e) => {
			e.name !== "AbortError" && (O(e.message), T(!1));
		}), () => e.abort();
	}, [t]), r(() => {
		if (!n || n.length === 0) return;
		let e = new AbortController();
		return T(!0), O(null), Promise.all(n.map((t) => fetch(t, { signal: e.signal }).then((e) => {
			if (!e.ok) throw Error(`Failed to fetch from ${t}: ${e.statusText}`);
			return e.json();
		}))).then((e) => {
			let t = e.flatMap((e) => e.events || []), n = {
				...e[0],
				events: t
			};
			C(n), T(!1);
		}).catch((e) => {
			e.name !== "AbortError" && (O(e.message), T(!1));
		}), () => e.abort();
	}, [n]), r(() => {
		e && C(e);
	}, [e]);
	let A = typeof u == "string" ? u : u?.name || "classic", j = {};
	typeof u == "object" && u && (u.backgroundColor && (j["--timeline-bg"] = u.backgroundColor), u.eventColor && (j["--event-default-color"] = u.eventColor), u.eventTextColor && (j["--event-text-color"] = u.eventTextColor), u.tapeColor && (j["--tape-default-color"] = u.tapeColor), u.fontFamily && (j["--timeline-font-family"] = u.fontFamily), u.fontSize && (j["--event-font-size"] = u.fontSize), u.scaleColor && (j["--scale-text-color"] = u.scaleColor), u.gridColor && (j["--scale-line-color"] = u.gridColor), u.hotZoneColor && (j["--hot-zone-default-color"] = u.hotZoneColor));
	let M = {
		width: typeof f == "number" ? `${f}px` : f,
		height: typeof m == "number" ? `${m}px` : m,
		position: "relative",
		overflow: "hidden",
		...j,
		...b
	};
	if (w) return /* @__PURE__ */ s("div", {
		className: `timeline-root ${y || ""}`,
		style: M,
		"data-theme": A,
		"data-testid": "timeline-container",
		children: /* @__PURE__ */ s("div", {
			className: "timeline-loading",
			children: "Loading timeline..."
		})
	});
	if (D) return /* @__PURE__ */ s("div", {
		className: `timeline-root ${y || ""}`,
		style: M,
		"data-theme": A,
		"data-testid": "timeline-container",
		children: /* @__PURE__ */ c("div", {
			className: "timeline-error",
			children: ["Error: ", D]
		})
	});
	if (!S || !S.events || S.events.length === 0) return /* @__PURE__ */ s("div", {
		className: `timeline-root ${y || ""}`,
		style: M,
		"data-theme": A,
		"data-testid": "timeline-container",
		children: /* @__PURE__ */ s("div", {
			className: "timeline-empty",
			children: "No timeline data available"
		})
	});
	let N = i && i.length > 0 ? i : void 0, P = d ? d instanceof Date ? d : p(d) ?? void 0 : void 0, F = x === !0 ? {} : x === !1 || x === void 0 ? null : x;
	return /* @__PURE__ */ c("div", {
		ref: k,
		className: `timeline-root ${y || ""}`,
		style: M,
		"data-theme": A,
		"data-testid": "timeline-container",
		role: "region",
		"aria-label": "Timeline visualization",
		"aria-roledescription": "interactive timeline",
		children: [/* @__PURE__ */ c(E, {
			events: S.events,
			bands: N,
			hotZones: l,
			initialCenterDate: P,
			onScroll: _,
			onEventClick: h,
			onEventHover: g,
			children: [/* @__PURE__ */ s(he, {}), /* @__PURE__ */ s(me, {
				containerRef: k,
				themeAttr: A,
				themeStyles: j
			})]
		}), F && /* @__PURE__ */ s(ge, { config: F })]
	});
}
//#endregion
export { fe as Band, C as DEFAULT_BANDS, ae as EventMarker, me as EventPopup, oe as EventTrack, ce as OverviewMarkers, y as TIME_UNITS, L as TimeScale, _e as Timeline, E as TimelineProvider, N as addInterval, M as alignToUnit, Z as assignTracks, te as calculateLayout, Q as calculateLayoutPrepared, h as dateToPixel, K as estimateLabelWidth, q as filterVisibleEvents, X as filterVisiblePrepared, m as formatDate, F as generateTicks, v as getMedianDate, j as getScaleConfig, $ as getTrackCount, _ as getVisibleRange, f as parseDate, g as pixelToDate, J as prepareEvents, k as usePan, D as useTimelineContext };

//# sourceMappingURL=index.js.map